import React from 'react';
import { Star, Swords, Shield, Brain, Heart } from 'lucide-react';
import type { UserItem } from '../../types/items';

interface ItemGridProps {
  items: UserItem[];
}

export function ItemGrid({ items }: ItemGridProps) {
  const rarityColors = {
    common: 'text-gray-400',
    uncommon: 'text-green-400',
    rare: 'text-blue-400',
    epic: 'text-purple-400',
    legendary: 'text-yellow-400'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item) => (
        <div key={item.id} className="bg-gray-800 rounded-lg p-6 space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-bold text-white">{item.name}</h3>
            <Star className={`w-5 h-5 ${rarityColors[item.rarity]}`} />
          </div>

          <img
            src={item.imageUrl}
            alt={item.name}
            className="w-full h-48 object-cover rounded-lg"
          />

          <div className="space-y-2">
            <div className="text-sm text-gray-400 capitalize">
              {item.type} • Quantity: {item.quantity}
            </div>

            <div className="grid grid-cols-2 gap-2">
              {item.stats.strength && (
                <div className="flex items-center gap-1 text-sm">
                  <Swords className="w-4 h-4 text-red-400" />
                  <span className="text-red-400">STR: {item.stats.strength}</span>
                </div>
              )}
              {item.stats.agility && (
                <div className="flex items-center gap-1 text-sm">
                  <Shield className="w-4 h-4 text-green-400" />
                  <span className="text-green-400">AGI: {item.stats.agility}</span>
                </div>
              )}
              {item.stats.intelligence && (
                <div className="flex items-center gap-1 text-sm">
                  <Brain className="w-4 h-4 text-blue-400" />
                  <span className="text-blue-400">INT: {item.stats.intelligence}</span>
                </div>
              )}
              {item.stats.vitality && (
                <div className="flex items-center gap-1 text-sm">
                  <Heart className="w-4 h-4 text-pink-400" />
                  <span className="text-pink-400">VIT: {item.stats.vitality}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}